import { useEstiloDeImpresion } from '../experiencia/estiloDeImpresion';
import { ArrowLeft, Printer } from 'lucide-react';
import CodigoQR from '../ui/CodigoQR';
import { contenidoDelQR } from '../accesos/enlaceDeEtiqueta';

// Cinta de impresión (PRD §5.C): la hoja lista para mandar a la impresora
// de etiquetas. Todo lo que no es etiqueta desaparece al imprimir, para que
// no se cuele la barra lateral en el papel.
export default function CintaImpresion({ etiquetas, onVolver }) {
  // Hoja construida, no <style>: la CSP de producción tira el <style>
  // (ver experiencia/estiloDeImpresion.js, 19 sep 2026).
  useEstiloDeImpresion(`
      @media print {
        body * { visibility: hidden; }
        #cinta-impresion, #cinta-impresion * { visibility: visible; }
        #cinta-impresion { position: absolute; inset: 0; margin: 0; }
        .sin-imprimir { display: none !important; }
        .etiqueta-qr { break-inside: avoid; }
      }
    `);

  return (
    <div className="space-y-4">
      {/* EL TÍTULO VA DENTRO DE `sin-imprimir`, como todo lo demás que no
          es etiqueta. Era la única pantalla de TEGO sin uno (medido en
          `docs-funcionales/USUARIO-CERO-PANTALLAS.md`, 29 ago 2026): se
          llega a ella desde Etiquetas, así que el hueco era pequeño —
          pero es la pantalla en la que alguien gasta papel, y llegar a
          una hoja de códigos sin nada que diga qué es se parece
          demasiado a haber pulsado el botón equivocado. */}
      <header className="sin-imprimir">
        <h1 className="text-xl font-semibold text-gray-900">
          Hoja de etiquetas
        </h1>
        <p className="text-sm text-gray-500 mt-0.5">
          Lo que va a salir por la impresora. Nada de esta pantalla se
          imprime salvo las etiquetas de abajo.
        </p>
      </header>

      <div className="sin-imprimir flex items-center justify-between gap-3 flex-wrap">
        <button onClick={onVolver} className="inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--color-marca)]">
          <ArrowLeft className="h-4 w-4" /> Volver a Etiquetas
        </button>
        <div className="flex items-center gap-3">
          <span className="text-sm text-gray-500">{etiquetas.length} etiqueta{etiquetas.length === 1 ? '' : 's'}</span>
          <button
            onClick={() => window.print()}
            className="inline-flex items-center gap-1.5 bg-[var(--color-marca)] hover:bg-[var(--color-marca-fuerte)] text-white text-sm font-semibold px-3 py-2 rounded-lg"
          >
            <Printer className="h-4 w-4" /> Imprimir
          </button>
        </div>
      </div>

      <p className="sin-imprimir text-sm text-gray-500">
        Revisa la hoja antes de imprimir. Si tu impresora es de rollo, elige tamaño de papel “etiqueta” en el
        diálogo del navegador; si es de hoja, salen varias por página.
      </p>

      <div id="cinta-impresion" className="bg-white border border-gray-200 rounded-xl p-4">
        <div className="flex flex-wrap gap-4">
          {etiquetas.map((e) => (
            <div key={e.codigo} className="etiqueta-qr w-40 border border-gray-300 rounded p-2 flex flex-col items-center gap-1">
              <CodigoQR valor={contenidoDelQR(e)} tamano={120} />
              <p className="font-mono text-[11px] text-black break-all text-center leading-tight">{e.codigo}</p>
              <p className="text-[10px] text-gray-700 text-center leading-tight line-clamp-2">{e.producto}</p>
              {e.ubicacion && <p className="text-[10px] text-gray-500">{e.ubicacion}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
